export const localization = () =>{
    return(
        {
            th:{
                myDataHeader:'สถานที่ของฉัน',
                anonymousMode:'โหมดผู้ใช้งานทั่วไป',
                editorMode:'โหมดแก้ไขข้อมูล',
                pinButton:'ปักหมุดสถานที่',
                findButton:'ค้นหาเตียงว่างใกล้ฉัน',
                createNewData:'สร้างข้อมูลสถานที่',
                placeName:'ชื่อสถานที่',
                staffName:'ชื่อเจ้าหน้าที่',
                detail:'รายละเอียดเพิ่มเติม',
                phone:'เบอร์โทร',
                capacity:'เตียงทั้งหมด',
                available:'เตียงว่าง',
                picUrl:'ภาพสถานที่',
                type:'ประเภท',
                findHeader:'ค้นหาสถานที่',
                findInputPlaceHolder:'ค้นหาจากชื่อ',
                menuLoginFooterString:'*สำหรับเจ้าหน้าที่ปรับปรุงข้อมูลกรุณา Log in\nหากท่านใดต้องการเพิ่มข้อมูลกรุณาติดต่อที่',
                callButton:'โทร',
                directionButton:'ดูเส้นทาง',
                callTxt:'เบอร์โทร',
                dataInfo:'ข้อมูล สถานที่',
                bedInfo:'ข้อมูล เตียง',
                locationInfo:'ข้อมูล พิกัด',
                updateDataInfo:'อัพเดทข้อมูล',
                dataId:'รหัสข้อมูล',
                normalHospital:'โรงพยาบาล',
                militaryHospital:'โรงพยาบาลทหาร',
                ci:'ศูนย์พักคอย (CI)',
                fieldHospital:'โรงพยาบาลสนาม',
                hi:'Home Isolation',
                hospitel:'Hospitel',
                allType:'ทั้งหมด',
                missingValuesTxt:'กรุณาระบุข้อมูล!',
                updateAtTxt:'อัพเดทข้อมูลล่าสุดเมื่อ', 
                statInfo:'ข้อมูลในระบบ',
                availableBed:'เตียงว่าง',
                capacityBed:'เตียงทั้งหมด'
            },
            en:{
                myDataHeader:'My Places Data',
                anonymousMode:'User mode',
                editorMode:'Editor Mode',
                pinButton:'Pin My Places',
                findButton:'Find Nearby Me',
                createNewData:'Create New',
                placeName:'Places Name',
                staffName:'Staff Name',
                detail:'More Details',
                phone:'Phone',
                capacity:'Bed Capacity',
                available:'Bed Available',
                picUrl:'Pic',
                type:'Type',
                findHeader:'Find Places',
                findInputPlaceHolder:'Find by name',
                menuLoginFooterString:'*For Admin please Log in\nIf you want to submit your information,Please contact us via',
                callButton:'Call',
                directionButton:'Get Direction',
                callTxt:'Phone',
                dataInfo:'Place Info.',
                bedInfo:'Bed Info.',
                locationInfo:'Location Info.',
                updateDataInfo:'Update Data',
                dataId:'Place Id',
                normalHospital:'Hospital',
                militaryHospital:'Military Hospital',
                ci:'Community Isolation',
                fieldHospital:'Field Hospital',
                hi:'Home Isolation',
                hospitel:'Hospitel',
                allType:'All Type',
                missingValuesTxt:'Please filling information!',
                updateAtTxt:'Updated At',
                statInfo:'Statistic Information',
                availableBed:'Available',
                capacityBed:'Capacity'
            }
        }
    )
}